import publicAxios from "../publicAxios";

// Public, unauthenticated course/event listing — used on the marketing site (/courses)
export const publicEventsApi = () => publicAxios.get("/events");
export const publicEventShowApi = (id) => publicAxios.get(`/events/${id}`);
export const publicCategoriesApi = () =>
  publicAxios.get("/event-categories?per_page=100");
export const publicSettingsApi = () => publicAxios.get("/settings/public");
